import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { MainStateType, TabType, MenuType } from '@redux/types'
import { firstMainTap } from '@redux/store/core/config.store'

const initialState: MainStateType = {
	// trigger
	triggerGetMenu: false,

	// menu
	menu: [],
	openedMenuIdArr: [],

	// tab
	selectedTabIdx: '1',
	tabList: [firstMainTap],
}

const slice = createSlice({
	name: 'main',
	initialState,
	reducers: {
		// trigger
		TRIGGER_GET_MENU: (state: MainStateType, action: PayloadAction<boolean>) => {
			state.triggerGetMenu = action.payload
		},

		// menu
		MENU: (state: MainStateType, action: PayloadAction<MenuType[]>) => {
			state.menu = action.payload
		},
		OPENED_MENU_ID_ARR: (state: MainStateType, action: PayloadAction<string[]>) => {
			state.openedMenuIdArr = action.payload
		},

		// tab
		SELECTED_TAB_IDX: (state: MainStateType, action: PayloadAction<string>) => {
			state.selectedTabIdx = action.payload
		},
		TAB_LIST: (state: MainStateType, action: PayloadAction<TabType[]>) => {
			state.tabList = action.payload
		},
	},
})

export const mainActions = slice.actions
export default slice.reducer
